'use client';

import { ReactNode } from 'react';
import NiceModal from '@ebay/nice-modal-react';

export const NiceModalProvider = ({ children }: { children: ReactNode }) => (
  <NiceModal.Provider>
    {children}
  </NiceModal.Provider>
);
